module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("82nSV"))).then(() => parcelRequire('1iHdE'));